export default __webpack_public_path__ + "static/media/event-prop-2.eefa3e1d.png";